import React, {
    useState,
    forwardRef,
    useImperativeHandle,
    useEffect,
    useRef
  } from "react";
  import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";
  import ImageBrowse from "../../../../Common/Image/ImageBrowse";
  import { IconPlus } from "@tabler/icons-react";
  import CommunityAdd from "./CommunityAdd";
  
  const Community = forwardRef((props, ref) => {
    const [errors, setErrors] = useState({});
    const slide1ImageRef = useRef();
    const slide2ImageRef = useRef();
    const slide3ImageRef = useRef();
  
    const [slide1ImageKey, setSlide1ImageKey] = useState(null);
    const [slide2ImageKey, setSlide2ImageKey] = useState(null);
    const [slide3ImageKey, setSlide3ImageKey] = useState(null);
  
    const [file1, setFile1] = useState(null);
    const [file2, setFile2] = useState(null);
    const [file3, setFile3] = useState(null);
  
    const [popularImages, setPopularImages] = useState([]);
  
    const [banners, setBanners] = useState({
      banner1: { title: "", subtitle: "", description: "" }
    });
  
    const handleChange = (bannerKey, field, value) => {
      setBanners((prev) => ({
        ...prev,
        [bannerKey]: {
          ...prev[bannerKey],
          [field]: value
        }
      }));
    };
  
    useEffect(() => {
      resetData();
      if (props.data) {
        if (props.data.length > 0) {
          setSlide1ImageKey(props.data[0].imageKey);
          slide1ImageRef?.current?.setThumbnail(props.data[0].image);
          slide1ImageRef?.current?.setFileContent(props.data[0].imageFile);
        }
        if (props.data.length > 1) {
          setSlide2ImageKey(props.data[1].imageKey);
          slide2ImageRef?.current?.setThumbnail(props.data[1].image);
          slide2ImageRef?.current?.setFileContent(props.data[1].imageFile);
        }
        if (props.data.length > 2) {
          setSlide3ImageKey(props.data[2].imageKey);
          slide3ImageRef?.current?.setThumbnail(props.data[2].image);
          slide3ImageRef?.current?.setFileContent(props.data[2].imageFile);
        }
      }
    }, [props.data]);
  
    const resetData = () => {
      [slide1ImageRef, slide2ImageRef, slide3ImageRef].forEach((ref) => {
        ref?.current?.setThumbnail(null);
        ref?.current?.setFileContent(null);
      });
      setSlide1ImageKey(null);
      setSlide2ImageKey(null);
      setSlide3ImageKey(null);
    };
  
    const validate = () => {
      const errors = {};
      setErrors(errors);
      return Object.keys(errors).length === 0;
    };
  
    const getData = () => {
      let sliders = [];
  
      if (slide1ImageRef?.current?.getThumbnail()) {
        sliders.push({
          image: slide1ImageRef?.current?.getThumbnail(),
          imageFile: slide1ImageRef?.current?.getImageFile(),
          imageKey: slide1ImageKey
        });
      }
      if (slide2ImageRef?.current?.getThumbnail()) {
        sliders.push({
          image: slide2ImageRef?.current?.getThumbnail(),
          imageFile: slide2ImageRef?.current?.getImageFile(),
          imageKey: slide2ImageKey
        });
      }
      if (slide3ImageRef?.current?.getThumbnail()) {
        sliders.push({
          image: slide3ImageRef?.current?.getThumbnail(),
          imageFile: slide3ImageRef?.current?.getImageFile(),
          imageKey: slide3ImageKey
        });
      }
  
      let aboutData = [];
      popularImages.forEach((item) => {
        let data = item.ref?.getData();
        if (data) aboutData.push(data);
      });
  
      return {
        Heading: banners.banner1.title,
        Subheading: banners.banner1.subtitle,
        Description: banners.banner1.description,
        sliders,
        communitydata: aboutData
      };
    };
  
    useImperativeHandle(ref, () => ({
      getData,
      validate
    }));
  
    const handleCroppedImage1 = (file) => {
      setFile1(file);
      updateSliderProps(file, file2, file3);
    };
    const handleCroppedImage2 = (file) => {
      setFile2(file);
      updateSliderProps(file1, file, file3);
    };
    const handleCroppedImage3 = (file) => {
      setFile3(file);
      updateSliderProps(file1, file2, file);
    };
  
    const updateSliderProps = (img1, img2, img3) => {
      if (props.section) {
        props.section([{ image1: img1, image2: img2, image3: img3 }]);
      }
    };
  
    const handleAddpopImg = () => {
      setPopularImages([
        ...popularImages,
        {
          name: "Community " + (popularImages.length + 1),
          image: null,
          imageFile: null,
          imageKey: "",
          show: popularImages.length === 0,
          ref: null
        }
      ]);
    };
  
    const showHidePopimgs = (index) => {
      const updated = popularImages.map((img, idx) => ({
        ...img,
        show: idx === index ? !img.show : false
      }));
      setPopularImages(updated);
    };
  
    const deletePopImgHandler = (targetIndex) => {
      const filtered = popularImages.filter((_, idx) => idx !== targetIndex);
  
      if (filtered.length === 1) {
        filtered[0]["show"] = true;
      }
  
      const deleted = popularImages[targetIndex];
      if (deleted?.imageKey) {
        props.imageDelete(deleted.imageKey);
      }
  
      setPopularImages(filtered);
    };
  
    const imageDeleteHandler = (imageKey) => {
      props.imageDelete(imageKey);
    };
  
    return (
      <>
        <div className="content d-block visible">
          <div className="content-header mb-3 d-flex justify-content-between">
            <div className="sec-titler">
              <h2 className="text-primary">Community Page</h2>
              <div className="title-shape"></div>
            </div>
            <div>
              <button className="btn btn-primary" onClick={handleAddpopImg}>
                <IconPlus className="me-sm-1 me-0" size={20} />
                Add Community
              </button>
            </div>
          </div>
  
          <div className="row g-3">
            <div className="col-sm-6">
              <label className="form-label">Community Header</label>
              <input
                type="text"
                className="form-control"
                value={banners.banner1.title}
                onChange={(e) => handleChange("banner1", "title", e.target.value)}
                placeholder="Please enter the main title here"
              />
            </div>
            <div className="col-sm-6">
              <label className="form-label">Community Sub-Heading</label>
              <input
                type="text"
                className="form-control"
                value={banners.banner1.subtitle}
                onChange={(e) => handleChange("banner1", "subtitle", e.target.value)}
                placeholder="Please enter the sub heading here"
              />
            </div>
            <div className="col-sm-12">
              <label className="form-label">Community Description</label>
              <textarea
                className="form-control"
                value={banners.banner1.description}
                onChange={(e) => handleChange("banner1", "description", e.target.value)}
                placeholder="Please enter the description"
                style={{ height: "200px", resize: "none" }}
              />
            </div>
          </div>
  
          <br />
  
          <div className="row g-3">
            {errors.noSlider && (
              <div style={{ color: "#ea5455", fontSize: "0.8125rem" }}>
                {errors.noSlider}
              </div>
            )}
            <div className="col-sm-4">
              <label className="form-label">Dimension: 424px x 498px</label>
              <ImageBrowse
                elementId="slide1Image"
                ref={slide1ImageRef}
                imageType="community1"
                imageKey={slide1ImageKey}
                setImageKey={setSlide1ImageKey}
                imageDelete={props.imageDelete}
                onImageCropped={handleCroppedImage1}
              />
            </div>
            <div className="col-sm-4">
              <label className="form-label">Dimension: 424px x 498px</label>
              <ImageBrowse
                elementId="slide2Image"
                ref={slide2ImageRef}
                imageType="community1"
                imageKey={slide2ImageKey}
                setImageKey={setSlide2ImageKey}
                imageDelete={props.imageDelete}
                onImageCropped={handleCroppedImage2}
              />
            </div>
            <div className="col-sm-4">
              <label className="form-label">Dimension: 424px x 320px</label>
              <ImageBrowse
                elementId="slide3Image"
                ref={slide3ImageRef}
                imageType="community2"
                imageKey={slide3ImageKey}
                setImageKey={setSlide3ImageKey}
                imageDelete={props.imageDelete}
                onImageCropped={handleCroppedImage3}
              />
            </div>
          </div>
  
         
          <div className="accordion mt-3">
            {popularImages.map((img, idx) => (
              <CommunityAdd
                key={idx}
                data={img}
                index={idx}
                showHidePople={showHidePopimgs}
                deletePeople={deletePopImgHandler}
                imageDelete={imageDeleteHandler}
                ref={(el) => (img.ref = el)}
              />
            ))}
          </div>
        </div>
        <StepperNavigationButtons
            index={props.index}
            steps={props.steps}
            navigate={props.navigate}
            save={props.save}
          />
  
      </>
    );
  });
  
  export default Community;
  